import { MRT_ColumnDef } from 'mantine-react-table'
import { Text } from '@mantine/core'
import { ReactNode } from 'react'
import Pill, { PillColor } from 'app/views/components/Table/Pill'
import { EntityScreenRow } from 'app/models/entity-screen-row'
import EntityActions from './entity-actions'
import { kycStatusOptions } from 'app/models/dropdown-options'

export type EntityColsTableDefs = {
  entityName: string
  internalId: string
  status: StatusState
  mei: string
  kycType: string
  entityType: string
  entityProfile: string
  parent: string
  taxFormStatus: string
  kycStatus: string
  id: string
  original: EntityScreenRow
}

export enum StatusState {
  Active = 'Active',
  Unapproved = 'Unapproved',
  PendingKYC = 'Pending KYC',
  Inactive = 'Inactive',
}

const getPillColor = new Map<StatusState, PillColor>()
getPillColor.set(StatusState.Active, PillColor.GREEN)
getPillColor.set(StatusState.Unapproved, PillColor.PINK)
getPillColor.set(StatusState.PendingKYC, PillColor.ORANGE)
getPillColor.set(StatusState.Inactive, PillColor.GREY)

function TableHead({ header }: { header: string }) {
  return (
    <Text
      style={{
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '1.5em',
      }}
    >
      {header}
    </Text>
  )
}

function TableRowText({ text }: { text: ReactNode }) {
  return (
    <Text
      style={{
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '1.5em',
      }}
    >
      {text}
    </Text>
  )
}

export const entityCols: MRT_ColumnDef<EntityColsTableDefs>[] = [
  {
    size: 200,
    accessorKey: 'entityName',
    header: 'Entity Name',
    Header: <TableHead header={'Entity Name'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>()} />,
  },
  {
    accessorKey: 'internalId',
    header: 'Internal Entity ID',
    Header: <TableHead header={'Internal Entity ID'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>()} />,
  },
  {
    size: 100,
    accessorKey: 'status',
    header: 'Status',
    Header: <TableHead header={'Status'} />,
    Cell: ({ cell }) => {
      const color: PillColor =
        getPillColor.get(cell.getValue<StatusState>()) ?? PillColor.GREY
      return <Pill text={(cell.getValue<StatusState>() as string) ?? ''} color={color} />
    },
  },
  {
    size: 100,
    accessorKey: 'mei',
    header: 'MEI',
    Header: <TableHead header={'MEI'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>()} />,
  },
  {
    size: 110,
    accessorKey: 'kycType',
    header: 'KYC Type',
    Header: <TableHead header={'KYC Type'} />,
    Cell: ({ cell }) => {
      return <TableRowText text={cell.getValue<string>()} />
    },
  },
  {
    size: 80,
    accessorKey: 'entityType',
    header: 'Type',
    Header: <TableHead header={'Type'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>()} />,
  },
  {
    accessorKey: 'entityProfile',
    header: 'Profile',
    Header: <TableHead header={'Profile'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>()} />,

  },
  {
    accessorKey: 'parent',
    header: 'Fund Manager / Parent',
    Header: <TableHead header={'Fund Manager / Parent'} />,
    Cell: ({ cell }) => {
      return (
        <TableRowText text={cell.getValue<string>()} />
      )
    },
  },
  {
    accessorKey: 'taxFormStatus',
    header: 'Tax Form Status',
    Header: <TableHead header={'Tax Form Status'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>().replace("_", " ")} />,
  },
  {
    accessorKey: 'kycStatus',
    header: 'KYC Status',
    Header: <TableHead header={'KYC Status'} />,
    Cell: ({ cell }) => <TableRowText text={kycStatusOptions?.find(
      option => option.value === cell.getValue<string>()
    )?.label ?? 'Pending'} />,
  },
  {
    size: 110,
    accessorKey: 'id',
    header: 'Actions',
    Header: <TableHead header={'Actions'} />,
    enableColumnActions: false,
    enableColumnFilter: false,
    Cell: cell => <EntityActions row={cell.row.original.original} fetchOnOpen />,
  },
]
